// @react/hooks/useFiscalizationFiscalProvider.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { fiscalizationFiscalProviderStore } from '@core/stores';

/**
 * React hook for FiscalProvider operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useFiscalizationFiscalProvider } from '@react/hooks';
 *
 * const FiscalProviderList = observer(() => {
 *   const store = useFiscalizationFiscalProvider();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useFiscalizationFiscalProvider() {
  return fiscalizationFiscalProviderStore;
}
